<template>
  <div>
    <!--Header-->
    <div class="header bg-success pt-5 pb-4">
      <b-container fluid>
        <div class="header-body">
          <b-row align-v="center">
            <b-col lg="12 mt-5">
              <div class="pr-6">
                <h1 class="display-3 text-white font-weight-bold mb-0">
                  Azure DevOps Integration Instant Syncing
                </h1>
                <h2 class="display-4 text-white font-weight-light">
                  Zendesk, Freshdesk, Freshservice, monday Azure DevOps Integration
                  provides Syncing of Data (Comments, Status and Attachments).
                </h2>
                <p class="text-white mt-4">
                  Syncing of Comments, Status and Attachments from Azure DevOps
                  to Zendesk, Freshdesk, Freshservice, monday
                </p>
                <p class="text-white mt-2">
                  We are providing the few types of syncing of comments from
                  Azure DevOps:-
                </p>
                <ol class="text-white">
                  <li>
                    Syncing of all comments from Azure DevOps to
                    (Zendesk,Freshdesk,Freshservice,monday).
                  </li>
                  <li>
                    Syncing of tag based comments from Azure DevOps to
                    (Zendesk,Freshdesk,Freshservice,monday).
                  </li>
                  <li>
                    Posting comment to (Zendesk,Freshdesk,Freshservice,monday) as
                    Public or Private tag based.
                  </li>
                </ol>
                <div class="text-white mb-4 font-weight-bold mt-5 text-center">
                  <strong class="display-3 text-primary  font-weight-bold mb-0">Start a free trial now,
                    <em>No credit card required</em></strong><br />
                  <router-link to="/apps/zendesk-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Zendesk Azure DevOps</router-link>
                  <router-link to="/apps/freshdesk-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Freshdesk Azure DevOps</router-link>
                  <router-link to="/apps/freshservice-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Freshservice Azure DevOps</router-link>

                  <router-link to="/apps/monday-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">monday Azure DevOps</router-link>
                </div>
                <p class="text-white">
                  We are providing the few types of syncing of comments from
                  Zendesk or Freshdesk or Freshservice or monday:-
                </p>
                <ol class="text-white">
                  <li>
                    Syncing of all comments from Zendesk, Freshdesk,
                    Freshservice, monday to Azure DevOps.
                  </li>
                  <li>
                    Syncing of tag based comments from Zendesk, Freshdesk,
                    Freshservice, monday to Azure DevOps.
                  </li>
                </ol>
                <div class="mt-3 mb-3">
                  <router-link to="/apps/zendesk-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Zendesk Azure DevOps Integration</router-link>
                  <router-link to="/apps/freshdesk-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Freshdesk Azure DevOps Integration</router-link>
                  <router-link to="/apps/freshservice-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">Freshservice Azure DevOps Integration</router-link>
                  <router-link to="/apps/monday-azure-devops-integration"
                    class="btn btn-neutral text-primary my-2">monday Azure DevOps Integration</router-link>
                  <a href="mailto:support@devopsintegration.io" class="btn btn-primary text-white my-2">Purchase App
                    Licence Now</a>
                </div>
                <p class="text-white">
                  We also support customization based on customer request and
                  tailored to your needs! We bring Azure DevOps closer to your
                  business requirements!
                </p>
                <p class="text-white">
                  The Zendesk-Azure DevOps app provides couple of options like
                  Create Work Item, Link Work Item, Notify, Work Item History &
                  Configure App.
                </p>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100" style="display:none">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-2 pl-5 pr-5 pb-9 text-white bg-default">
      <div class="container_fluid status-bg">
        <div class="row">
          <div class="col-lg-3 col-md-6" style="cursor:pointer"
            onclick="document.location.href='/apps/support/azure-devops-integration/';">
            <div class="status-card">
              <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
                Zendesk Azure DevOps
              </h3>
              <p>
                Azure DevOps integrates your work items. Create bugs, features,
                or custom work items. Use area paths, iteration, priority,
                severity.
              </p>
              <i class="flaticon-magnifying-glass"></i>
              <div class="status-bottom-1"></div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6" style="cursor:pointer"
            onclick="document.location.href='https://www.freshworks.com/apps/freshdesk_azure_devops_integration/';">
            <div class="status-card">
              <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
                Freshdesk Azure DevOps
              </h3>
              <p>
                Azure DevOps integrates your work items and your own custom
                fields. link existing bugs, features, or custom work items.
                Notify workitems.
              </p>
              <i class="flaticon-bank"></i>
              <div class="status-bottom-2"></div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 offset-lg-0 offset-md-3" style="cursor:pointer"
            onclick="document.location.href='https://www.freshworks.com/apps/freshservice_azure_devops_integration/';">
            <div class="status-card">
              <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
                Freshservice DevOps
              </h3>
              <p>
                Azure DevOps integration allows you to sync your comments,
                status, system fields and custom fields in both directions based
                on your needs.
              </p>
              <i class="flaticon-settings"></i>
              <div class="status-bottom-3"></div>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 offset-lg-0 offset-md-3" style="cursor:pointer"
            onclick="document.location.href='https://monday.com/marketplace/listing/10000746/azure-devops-integration-bisync';">
            <div class="status-card">
              <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
                monday DevOps
              </h3>
              <p>
                The connector enables real-time bi-directional synchronization of comments, attachments, and fields
                between monday.com and Azure DevOps. Any updates made in one platform are instantly reflected in the
                other, ensuring that teams working on different systems stay aligned.
              </p>
              <i class="flaticon-settings"></i>
              <div class="status-bottom-3"></div>
            </div>
          </div>

        </div>
      </div>
      <div class="container apps-div" style="margin-top:50px;">
        <div class="row">
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Zendesk - Azure DevOps Integration
            </h3>
            <p>
              The Zendesk-Azure DevOps app provides couple of options like
              Create Work Item, Link Work Item, Notify Linked Work Items, Work
              Item History, Enable Syncing & Configure App.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/zendesk/App.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/zendesk/screenshot-0.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Create Work Item:
            </h3>
            <p>
              The Create Work Item: lets the user to create new work item # in
              Azure DevOps from Zendesk, support agent can select type of work
              item he/she want to create like Bug, Epic, Feature, Task, User
              Story etc. Based on the work item type selection he will see all
              the Azure DevOps fields. The User can make the selection and click
              on Create button which would create work item in Azure DevOps and
              then display the corresponding Azure DevOps work item Id in the
              App.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Link Work Item:
            </h3>
            <p>
              Using this button in Zendesk-DevOps app support agent can link an
              existing Azure DevOps Workitem # to current Zendesk ticket.
              Zendesk-Azure DevOps app allows the user to create or link
              multiple work items to one Zendesk ticket.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/zendesk/LinkWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/zendesk/Notify.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">Notify:</h3>
            <p>
              Notify button in Zendesk-Azure DevOps app allows the support agent
              to notify all the linked Azure DevOps work items to current
              Zendesk ticket these will show up as comments in Azure DevOps.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Work Item History:
            </h3>
            <p>
              In the Zendesk-Azure DevOps app Work Item History modal shows you
              couple of details of work item history including the comments
              history to current Zendesk ticket.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/zendesk/WorkItemLog.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-12">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Enable Syncing:
            </h3>
            <p>
              In the Zendesk-Azure DevOps app Enable Syncing lets you enable the
              syncing of data from Zendesk to Azure DevOps and Azure DevOps to
              Zendesk.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/zendesk/SearchWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Configure App:
            </h3>
            <p>
              In the Zendesk-Azure DevOps app Configure App lets you enable the
              syncing of few fields from Zendesk to Azure DevOps and Azure
              DevOps to Zendesk.
            </p>
          </div>
          <div class="col-md-12">
            <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
              <a href="/apps/support/azure-devops-integration" target="_blank" class="btn btn-primary">Click to Install
                the app</a>
              <router-link to="/contact" class="btn btn-primary text-center book-btn">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container apps-div" style="margin-top:50px;">
        <div class="row">
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Freshdesk - Azure DevOps Integration
            </h3>
            <p>
              The Freshdesk-Azure DevOps app provides couple of options like
              Create Work Item, Link Work Item, Notify Linked Work Items, Work
              Item History, Enable Syncing & Configure App.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshdesk/App.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshdesk/CreateWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Create Work Item:
            </h3>
            <p>
              The Create Work Item: lets the user to create new work item # in
              Azure DevOps from Freshdesk, support agent can select type of work
              item he/she want to create like Bug, Epic, Feature, Task, User
              Story etc. Based on the work item type selection he will see all
              the Azure DevOps fields. The User can make the selection and click
              on Create button which would create work item in Azure DevOps and
              then display the corresponding Azure DevOps work item Id in the
              App.
            </p>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Link Work Item:
            </h3>
            <p>
              Using this button in Freshdesk-DevOps app support agent can link
              an existing Azure DevOps Workitem # to current Freshdesk ticket.
              Freshdesk-Azure DevOps app allows the user to create or link
              multiple work items to one Freshdesk ticket.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshdesk/LinkWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshdesk/Notify.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">Notify:</h3>
            <p>
              Notify button in Freshdesk-Azure DevOps app allows the support
              agent to notify all the linked Azure DevOps work items to current
              Freshdesk ticket these will show up as comments in Azure DevOps.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Work Item History:
            </h3>
            <p>
              In the Freshdesk-Azure DevOps app Work Item History modal shows
              you couple of details of work item history including the comments
              history to current Freshdesk ticket.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshdesk/WorkItemLog.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-12">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Enable Syncing:
            </h3>
            <p>
              In the Freshdesk-Azure DevOps app Enable Syncing lets you enable
              the syncing of data from Freshdesk to Azure DevOps and Azure
              DevOps to Freshdesk.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshdesk/SearchWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Configure App:
            </h3>
            <p>
              In the Freshdesk-Azure DevOps app Configure App lets you enable
              the syncing of few fields from Freshdesk to Azure DevOps and Azure
              DevOps to Freshdesk.
            </p>
          </div>

          <div class="col-md-12">
            <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
              <a href="https://www.freshworks.com/apps/freshdesk_azure_devops_integration/" target="_blank"
                class="btn btn-primary">Click to Install the app</a>
              <router-link to="/contact" class="btn btn-primary text-center book-btn">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container apps-div" style="margin-top:50px;">
        <div class="row">
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Freshservice - Azure DevOps Integration
            </h3>
            <p>
              The Freshservice-Azure DevOps app provides couple of options like
              Create Work Item, Link Work Item, Notify Linked Work Items, Work
              Item History, Enable Syncing & Configure App.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshservice/App.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshservice/CreateWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Create Work Item:
            </h3>
            <p>
              The Create Work Item: lets the user to create new work item # in
              Azure DevOps from Freshservice, support agent can select type of
              work item he/she want to create like Bug, Epic, Feature, Task,
              User Story etc. Based on the work item type selection he will see
              all the Azure DevOps fields. The User can make the selection and
              click on Create button which would create work item in Azure
              DevOps and then display the corresponding Azure DevOps work item
              Id in the App.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Link Work Item:
            </h3>
            <p>
              Using this button in Freshservice-DevOps app support agent can
              link an existing Azure DevOps Workitem # to current Freshservice
              ticket. Freshservice-Azure DevOps app allows the user to create or
              link multiple work items to one Freshservice ticket.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshservice/LinkWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshservice/Notify.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">Notify:</h3>
            <p>
              Notify button in Freshservice-Azure DevOps app allows the support
              agent to notify all the linked Azure DevOps work items to current
              Freshservice ticket these will show up as comments in Azure
              DevOps.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Work Item History:
            </h3>
            <p>
              In the Freshservice-Azure DevOps app Work Item History modal shows
              you couple of details of work item history including the comments
              history to current Freshservice ticket.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshservice/WorkItemLog.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-12">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Enable Syncing:
            </h3>
            <p>
              In the Freshservice-Azure DevOps app Enable Syncing lets you
              enable the syncing of data from Freshservice to Azure DevOps and
              Azure DevOps to Freshservice.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/freshservice/SearchWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Configure App:
            </h3>
            <p>
              In the Freshservice-Azure DevOps app Configure App lets you enable
              the syncing of few fields from Freshservice to Azure DevOps and
              Azure DevOps to Freshservice.
            </p>
          </div>
          <div class="col-md-12">
            <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
              <a href="https://www.freshworks.com/apps/freshservice_azure_devops_integration/" target="_blank"
                class="btn btn-primary">Click to Install the app</a>
              <router-link to="/contact" class="btn btn-primary text-center book-btn">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>

      <!--monday starts here-->
      <div class="container apps-div" style="margin-top:50px;">
        <div class="row">
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              monday - Azure DevOps Integration
            </h3>
            <p>
              The monday-Azure DevOps app provides couple of options like
              Create Work Item, Link Work Item, Notify Linked Work Items, Work
              Item History, Enable Syncing & Configure App.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/monday/App.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, monday Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, monday - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/monday/CreateWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, monday Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, monday - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Create Work Item:
            </h3>
            <p>
              The Create Work Item: lets the user to create new work item # in
              Azure DevOps from monday, support agent can select type of
              work item he/she want to create like Bug, Epic, Feature, Task,
              User Story etc. Based on the work item type selection he will see
              all the Azure DevOps fields. The User can make the selection and
              click on Create button which would create work item in Azure
              DevOps and then display the corresponding Azure DevOps work item
              Id in the App.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Link Work Item:
            </h3>
            <p>
              Using this button in monday-DevOps app support agent can
              link an existing Azure DevOps Workitem # to current monday
              item. monday-Azure DevOps app allows the user to create or
              link multiple work items to one monday item.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/monday/LinkWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, monday Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, monday - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/monday/Notify.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, monday Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, monday - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">Notify:</h3>
            <p>
              Notify button in monday-Azure DevOps app allows the support
              agent to notify all the linked Azure DevOps work items to current
              monday item these will show up as comments in Azure
              DevOps.
            </p>
          </div>

          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Work Item History:
            </h3>
            <p>
              In the monday-Azure DevOps app Work Item History modal shows
              you couple of details of work item history including the comments
              history to current monday item.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/monday/WorkItemLog.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, monday Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, monday - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-12">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Enable Syncing:
            </h3>
            <p>
              In the monday-Azure DevOps app Enable Syncing lets you
              enable the syncing of data from monday to Azure DevOps and
              Azure DevOps to monday.
            </p>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <img src="assets/img/apps/monday/SearchWorkItem.png" class="apps-img"
                alt="Zendesk Azure Devops Connector, Freshdesk Azure Devops Connector, monday Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, monday - Azure DevOps Integration" />
            </div>
          </div>
          <div class="col-md-6">
            <h3 class="text-uppercase ls-1 text-primary py-3 mb-0">
              Configure App:
            </h3>
            <p>
              In the monday-Azure DevOps app Configure App lets you enable
              the syncing of few fields from monday to Azure DevOps and
              Azure DevOps to monday.
            </p>
          </div>
          <div class="col-md-12">
            <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
              <a href="https://monday.com/marketplace/listing/10000746/azure-devops-integration-bisync"
                target="_blank" class="btn btn-primary">Click to Install the app</a>
              <router-link to="/contact" class="btn btn-primary text-center book-btn">Contact Us</router-link>
            </div>
          </div>
        </div>
      </div>
      <!--monday ends here-->
    </section>
  </div>
</template>
<script>
import PricingQuote from "@/components/pricing-quote/pricing-quote.vue";
export default {
  components: { PricingQuote }
};
</script>
<style scoped></style>
